const STORAGE_KEY = "hub.tab_id";

/** When sessionStorage is unavailable, presence cannot stably identify this tab. */
export const HUB_TAB_ID_NO_STORAGE = "no-storage";

let memoized: string | null = null;

/**
 * Stable per-browser-tab identifier for Hub page presence. Stored in sessionStorage so a hard
 * reload of a working URL keeps the same tab identity.
 */
export function getHubTabId(): string {
  if (typeof window === "undefined") {
    return HUB_TAB_ID_NO_STORAGE;
  }
  if (memoized !== null) {
    return memoized;
  }
  try {
    const existing = window.sessionStorage.getItem(STORAGE_KEY);
    if (existing != null && existing.trim() !== "") {
      memoized = existing;
      return existing;
    }
    const next = crypto.randomUUID();
    window.sessionStorage.setItem(STORAGE_KEY, next);
    memoized = next;
    return next;
  } catch {
    memoized = HUB_TAB_ID_NO_STORAGE;
    return HUB_TAB_ID_NO_STORAGE;
  }
}

/** Test-only: clears the in-memory memo (does not clear sessionStorage). */
export function resetHubTabIdMemoForTests(): void {
  memoized = null;
}
